import React, { Component } from "react";
import PropTypes from "prop-types";
import logger from "common/logger";

const propTypes = {
  children: PropTypes.node.isRequired,
  log: PropTypes.bool,
  renderOnError: PropTypes.func // renderOnError can be be used to render a custom component
  // instead of the default markup provided down in render.
};

const defaultProps = {
  log: false,
  renderOnError: null
};

class ErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error, errorInfo) {
    if (this.props.log) {
      logger.notify(error, {
        request: error.request,
        response: error.response,
        info: errorInfo
      });
    }

    this.setState({ errorInfo });
  }

  render() {
    const { renderOnError } = this.props;
    if (this.state.error) {
      if (renderOnError) {
        return renderOnError(() => this.setState({ error: null }));
      }
      return (
        <>
          <h1>
            <i className="fa fa-chain-broken" /> Something went wrong
          </h1>
          <hr />
          <p>See javascript console for details.</p>
          <pre>
            <code>
              {this.state.error.messsage}
              {this.state.error.backtrace}
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </code>
          </pre>
          <button onClick={() => this.setState({ error: null })}>Retry</button>
        </>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = propTypes;

ErrorBoundary.defaultProps = defaultProps;

export default ErrorBoundary;
